function isTamaguiComponent(comp, name) {
  const config = comp == null ? void 0 : comp["staticConfig"];
  return (config == null ? void 0 : config.parsed) && (name ? name === config.componentName : true) || false;
}
export {
  isTamaguiComponent
};
//# sourceMappingURL=isTamaguiComponent.js.map
